import {useMemo} from 'react'
import {
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
} from '../core/QueryResponseProvider'
import {subscriptionPlansColumns} from './columns/_columns'
import {SubscriptionPlan} from '../core/_models'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {Table} from '../../../../../services/table/Table'

const SubscriptionPlansTable = () => {
  const subscriptionPlans = useQueryResponseData()
  const totalPages = Number(useQueryResponse().response?.data?.total_pages)
  const {updateState, state} = useQueryRequest()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => subscriptionPlans, [subscriptionPlans])
  const columns = useMemo(() => subscriptionPlansColumns, [])

  return (
    <Table<SubscriptionPlan>
      columns={columns}
      data={data}
      totalPages={totalPages}
      isLoading={isLoading}
      updateState={updateState}
      state={state}
      tableId='kt_table_enterprise_requests'
    />
  )
}

export {SubscriptionPlansTable}
